// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1MUiH","loadingShrink":"PageLoading_loadingShrink__1Gs2E"};